import React from "react";

export interface LoaderProps {
  message?: string;
  inline?: boolean;
  className?: string;
}

function Loader({ message, inline = false, className }: LoaderProps) {
  const classes = ["ui-loader", inline ? "ui-loader--inline" : null, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} role="status" aria-live="polite">
      <span className="ui-loader__dot" aria-hidden="true"></span>
      <span className="ui-loader__dot" aria-hidden="true"></span>
      <span className="ui-loader__dot" aria-hidden="true"></span>
      <span className="ui-loader__dot" aria-hidden="true"></span>
      <span className="ui-loader__dot" aria-hidden="true"></span>
      {message ? <p className="ui-loader__message">{message}</p> : null}
    </div>
  );
}

export default Loader;
